<template>
    <div v-if="additionals">
        <div v-if="additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-tabs>
                <rkm-tab title="Pendentes">
                    <rkm-data-table
                        :fields="fields.pendente"
                        :repository="repositories.requisicao"
                        :request-params="{status_id: [enums.requisicaoStatus.PENDENTE, enums.requisicaoStatus.RESPONDIDA]}"
                        ref="RkmDataTable"
                        search-by="unidadeNomeDe"
                    >
                        <template v-slot:cell(actions)="row">
                            <rkm-button
                                :title="editButtonTitle(row.item)"
                                @click="handleEdit(row.item.id)"
                                authorize="update-imunizacao-requisicao"
                                color="primary"
                                small
                            >
                                <rkm-icon :icon="editButtonIcon(row.item)" />
                            </rkm-button>

                            <rkm-button
                                title="Imprimir"
                                color="secondary"
                                @click="handlePrint(row.item.id)"
                                small
                            >
                                <rkm-icon icon="print"/>
                            </rkm-button>

                            <rkm-button
                                v-if="row.item.statusId === enums.requisicaoStatus.PENDENTE"
                                :disabled="row.item.salaVacinacaoIdDe !== additionals.salaVacinacaoLogada.id"
                                @click="destroy(row.item)"
                                authorize="destroy-imunizacao-requisicao"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>

                            <rkm-button
                                v-else
                                :disabled="row.item.statusId !== enums.requisicaoStatus.FINALIZADA || row.item.salaVacinacaoIdDe !== additionals.salaVacinacaoLogada.id"
                                @click="$refs.ModalEstorno.open(row.item)"
                                authorize="destroy-imunizacao-requisicao"
                                color="danger"
                                small
                                title="Estornar"
                            >
                                <rkm-icon icon="undo-alt" />
                            </rkm-button>
                        </template>
                    </rkm-data-table>
                </rkm-tab>

                <rkm-tab title="Finalizadas">
                    <rkm-data-table
                        :fields="fields.finalizada"
                        :repository="repositories.requisicao"
                        :request-params="{status_id: [enums.requisicaoStatus.FINALIZADA]}"
                        ref="RkmDataTable"
                    >
                        <template v-slot:cell(actions)="row">
                            <rkm-button
                                :title="editButtonTitle(row.item)"
                                @click="handleEdit(row.item.id)"
                                authorize="update-imunizacao-requisicao"
                                color="primary"
                                small
                            >
                                <rkm-icon :icon="editButtonIcon(row.item)" />
                            </rkm-button>

                            <rkm-button
                                title="Imprimir"
                                color="secondary"
                                @click="handlePrint(row.item.id)"
                                small
                            >
                                <rkm-icon icon="print"/>
                            </rkm-button>

                            <rkm-button
                                v-if="row.item.statusId === enums.requisicaoStatus.PENDENTE"
                                :disabled="row.item.salaVacinacaoIdDe !== additionals.salaVacinacaoLogada.id"
                                @click="destroy(row.item)"
                                authorize="destroy-imunizacao-requisicao"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>

                            <rkm-button
                                v-else
                                :disabled="row.item.statusId !== enums.requisicaoStatus.FINALIZADA || row.item.salaVacinacaoIdDe !== additionals.salaVacinacaoLogada.id"
                                @click="$refs.ModalEstorno.open(row.item)"
                                authorize="destroy-imunizacao-requisicao"
                                color="danger"
                                small
                                title="Estornar"
                            >
                                <rkm-icon icon="undo-alt" />
                            </rkm-button>
                        </template>
                    </rkm-data-table>
                </rkm-tab>
            </rkm-tabs>


            <ModalEstorno
                @save="$refs.RkmDataTable.refresh()"
                ref="ModalEstorno"
            />
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação ou está desativada, favor cadastra-la para efetuar uma requisição.
        </rkm-alert>
    </div>
</template>

<script>
// Components.
import ModalEstorno from './components/estorno/Modal'

// Enums.
import requisicaoStatus from '@/enums/imunizacao/requisicaoStatus'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalEstorno },
    computed: {
        fields() {
            return {
                pendente: [
                    { key: 'statusNome', label: 'Status', name: 'imunizacaoRequisicaoStatus.nome', searchable: true, sortable: true },
                    { key: 'unidadeNomeDe', label: 'Unidade requisitante', name: 'cadastroUnidadeDe.nomeFantasia', searchable: true, sortable: true },
                    { key: 'infraestruturaNomeDe', label: 'Local requisitante', name: 'cadastroInfraestruturaDe.nome', searchable: true, sortable: true },
                    { key: 'unidadeNomePara', label: 'Unidade requisitada', name: 'cadastroUnidadePara.nomeFantasia', searchable: true, sortable: true },
                    { key: 'infraestruturaNomePara', label: 'Local requisitado', name: 'cadastroInfraestruturaPara.nome', searchable: true, sortable: true },
                    { key: 'dataRequisicao', label: 'Data', name: 'imunizacaoRequisicao.dataRequisicao', searchable: true, sortable: true },
                    { key: 'codigo', label: 'Código', name: 'imunizacaoRequisicao.codigo', searchabCódigo: true, sortable: true },
                    { class: 'col-min text-center', key: 'actions', label: 'Ações' },
                ],
                finalizada: [
                    { key: 'unidadeNomeDe', label: 'Unidade requisitante', name: 'cadastroUnidadeDe.nomeFantasia', searchable: true, sortable: true },
                    { key: 'infraestruturaNomeDe', label: 'Local requisitante', name: 'cadastroInfraestruturaDe.nome', searchable: true, sortable: true },
                    { key: 'unidadeNomePara', label: 'Unidade requisitada', name: 'cadastroUnidadePara.nomeFantasia', searchable: true, sortable: true },
                    { key: 'infraestruturaNomePara', label: 'Local requisitado', name: 'cadastroInfraestruturaPara.nome', searchable: true, sortable: true },
                    { key: 'dataRequisicao', label: 'Data', name: 'imunizacaoRequisicao.dataRequisicao', searchable: true, sortable: true },
                    { key: 'codigo', label: 'Código', name: 'imunizacaoRequisicao.codigo', searchabCódigo: true, sortable: true },
                    { class: 'col-min text-center', key: 'actions', label: 'Ações' },
                ],
            }
        },
    },
    created() {
        this.repositories = {
            requisicao: this.getConectaSusRepository('imunizacao.requisicao'),
            impressao: this.getConectaSusRepository('impressao.imunizacao')
        }
    },
    data: () => ({
        additionals: null,
        enums: { requisicaoStatus },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.requisicao.index()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)

                    this.$emit('loaded', this.additionals)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(item) {
            const request = {
                tipoMovimentacao: 'estorno',
                id: item.id,
                statusId: item.statusId,
            }

            return this.repositories.requisicao.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => this.$refs.RkmDataTable.refresh())
        },
        handleEdit(id) {
            this.$router.push({ name: 'imunizacao-requisicao-edit', params: { id: id } })
        },
        destroy(item) {
            this.showDeleteConfirmation('Deseja realmente excluir a requisição?', () => this.handleDestroy(item), this.handleError)
        },
        editButtonTitle(item) {
            if (item.statusId === this.enums.requisicaoStatus.PENDENTE) {
                if (item.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    return 'Visualizar'
                } else {
                    return 'Responder'
                }
            }
            else if (item.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                if (item.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    return 'Responder'
                } else {
                    return 'Visualizar'
                }
            }
            else if (item.statusId === this.enums.requisicaoStatus.FINALIZADA) {
                return 'Visualizar'
            }
        },
        editButtonIcon(item) {
            if (item.statusId === this.enums.requisicaoStatus.PENDENTE) {
                if (item.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    return 'eye'
                } else {
                    return 'share'
                }
            }
            else if (item.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                if (item.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    return 'share'
                } else {
                    return 'eye'
                }
            }
            else if (item.statusId === this.enums.requisicaoStatus.FINALIZADA) {
                return 'eye'
            }
        },
        handlePrint(id)
        {
            this.setLoading()
            this.repositories.impressao.requisicao(id)
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
}
</script>